<template>
	<div class="order-detail-page">
		
		<!-- ===== 面包屑导航 ===== -->
		<div class="breadcrumb f-bct  animate__animated  ">
			<div class="breadcrumb-inner" @click="$router.back()">
				<span class="crumb-label">{{$t('omsg.t1')}}：</span>
				<span class="crumb-home">{{$t('omsg.t2')}}</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-current">{{$t('omsg.t3')}}</span>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 主体内容区域 ===== -->
		<div class="detail-body">

			<!-- ===== 左侧主区域 ===== -->
			<div class="main-area">

				<!-- 物流信息卡片 -->
				<div class="info-card logistics-card animate__animated  ">
					<div class="logistics-left">
						<div class="logistics-point">
							<div class="point-info">
								<div class="addrTxt f-ct">
									<div class="point-icon-wrap">
										<el-image :src="asset('30.svg')" class="point-icon-bg"></el-image>
										<span class="point-tag point-tag--start">始</span>
									</div>
									<span class="point-name">{{warehouse.name}}</span>
									<span class="point-country">{{warehouse.countryName}}</span>
								</div>
								<span class="point-desc">{{$t('omsg.t4')}}</span>
							</div>
						</div>
						<el-image :src="asset('32.svg')" class="arrow-line"></el-image>
						<div class="logistics-point">
							<div class="point-info">
								<div class="addrTxt f-ct">
										<div class="point-icon-wrap">
											<el-image :src="asset('31.svg')" class="point-icon-bg"></el-image>
											<span class="point-tag point-tag--end">终</span>
										</div>
									<span class="point-name">{{order.countryName}}</span>
								</div>
								<span class="point-desc">{{$t('omsg.t5')}}</span>
							</div>
						</div>
					</div>
					<div class="logistics-right">
						<span class="warehouse-no">订单号：{{order.orderSn}}</span>
						<el-image :src="asset('33.svg')" class="copy-icon" @click="handleCopy(order.orderSn)"></el-image>
					</div>
				</div>
				
				<!-- 收件人信息 -->
				<div class="info-card info-card-nb animate__animated  ">
					<div class="card-title-row f-bct">
						<div class="f-ct">
							<el-image :src="asset('26.svg')" class="title-icon"></el-image>
							<span class="title-text">收件人信息</span>
						</div>
						<div class="addrType" v-if="addressMsg.addressType==2">自提</div>
						<div class="addrType1" v-if="addressMsg.addressType==1">送货上门</div>
					</div>
					<div class="basic-rows">
						<div class="basic-row basic-row--1">
							<div class="basic-item">
								<label>姓名：</label>
								<value>{{addressMsg.consignee}}</value>
							</div>
							<div class="basic-item">
								<label>联系电话：</label>
								<value>{{addressMsg.mobile}}</value>
							</div>
							<div class="basic-item">
								<label>地址：</label>
								<value><span>{{addressMsg.countryName}}</span>{{addressMsg.provinceName}}{{addressMsg.cityName}}{{addressMsg.address}}</value>
							</div>
						</div>
					</div>
				</div>
				
				<!-- 基本信息卡片 -->
				<div class="info-card info-card-nb basic-card animate__animated  ">
					<div class="card-title-row">
						<el-image :src="asset('26.svg')" class="title-icon"></el-image>
						<span class="title-text">{{$t('omsg.t7')}}</span>
					</div>
					<div class="basic-rows">
						<div class="basic-row basic-row--1">
							<div class="basic-item">
								<label>{{$t('omsg.t8')}}：</label>
								<value>{{order.memberMarks}}</value>
							</div>
							<div class="basic-item">
								<label>{{$t('omsg.t9')}}：</label>
								<value>{{order.transportModeName}}</value>
							</div>
							<div class="basic-item" v-if="transportLine">
								<label>物流方案：</label>
								<value>{{transportLine.name}}</value>
							</div>
							<div class="basic-item">
								<label>{{$t('omsg.t14')}}：</label>
								<value v-if="order.customsClearanceType==1">{{$t('omsg.t15')}}</value>
								<value v-if="order.customsClearanceType==2">{{$t('omsg.t16')}}</value>
							</div>
							<div class="basic-item">
								<label>{{$t('omsg.t17')}}：</label>
								<value v-if="order.deliveryType==1">{{$t('omsg.t18')}}</value>
								<value v-if="order.deliveryType==2">{{$t('omsg.t19')}}</value>
							</div>
							<div class="basic-item">
								<label>货位号：</label>
								<value>{{order.goodsShelfNumber||$t('omsg.t21')}}</value>
							</div>
							<!-- <div class="basic-item ">
								<label>{{$t('omsg.t22')}}：</label>
								<value>{{order.goodsShelfAreasCode||$t('omsg.t21')}}</value>
							</div> -->
							<!-- <div class="basic-item ">
								<label>{{$t('omsg.t23')}}：</label>
								<value>{{order.mobile||$t('omsg.t21')}}</value>
							</div> -->
							<div class="basic-item">
								<label>{{$t('omsg.t24')}}：</label>
								<value>{{order.createTime}}</value>
							</div>
							<div class="basic-item">
								<label>{{$t('omsg.t25')}}：</label>
								<value>{{order.remark||$t('omsg.t21')}}</value>
							</div>
						</div>
					</div>
				</div>
				
			</div>

			<!-- ===== 右侧栏 ===== -->
			<div class="side-area">
			
				<!-- 物流情况 -->
				<div class="side-card logistics-status-card animate__animated  ">
					<div class="side-header" style="margin-bottom: 12px;">
						<div class="card-title-row">
							<el-image :src="asset('34.svg')" class="title-icon"></el-image>
							<span class="title-text">{{$t('omsg.o1')}}</span>
						</div>
						<!-- <div class="collapse-btn" @click="toggleLogistics">
							<span class="collapse-text">收缩</span>
							<el-image :src="asset('42.svg')" class="collapse-icon"></el-image>
						</div> -->
					</div>
					<div class="status-current" v-show="!isLogisticsCollapsed">{{$t('omsg.o2')}}：{{trackingList[0].name}}({{trackingList[0].createTime}})</div>
					<div class="timeline-wrap" v-show="!isLogisticsCollapsed">
						<div class="timeline-item" v-for="(step, index) in trackingList" :key="index">
							<div class="tl-dot-wrap">
								<el-image v-if="!index" :src="require('@/static/sel/17.svg')"></el-image>
								<el-image v-else :src="require('@/static/sel/16.svg')"></el-image>
							</div>
							<div class="tl-content">
								<div class="tl-name" :class="!index?'a1':''">{{step.name}}</div>
								<div class="tl-time" :class="!index?'a2':''">{{step.createTime}}</div>
							</div>
						</div>
					</div>
				</div>
			
			</div>
			
		</div>
		
		
		<!-- 费用信息表格 -->
		<div class="info-card fee-card animate__animated  ">
			<div class="f-bct">
				<div class="card-title-row">
					<el-image :src="asset('50.svg')" class="title-icon"></el-image>
					<span class="title-text">{{$t('omsg.pay1')}}</span>
				</div>
				<div class="pay-detail-btn" v-if="order.payStatus==0">待支付</div>
				<div class="pay-detail-btn" v-if="order.payStatus==1">已支付</div>
			</div>
			<div class="table-inner">
				<el-table
				ref="feeTable"
				:data="[1]"
				border
				header-cell-class-name="od-header-cell"
				cell-class-name="od-cell"
				style="width: 100%">
					<!-- <el-table-column label="序号" width="60" align="center">
						<template>1</template>
					</el-table-column> -->
					<el-table-column :label="$t('omsg.pay3')" width="180" align="center">
						<template v-if="order.payStatus==0">{{$t('omsg.pay4')}}</template>
						<template v-if="order.payStatus==1">{{$t('omsg.pay5')}}</template>
					</el-table-column>
					<el-table-column :label="$t('omsg.pay7')" width="160" align="center">
						<template>￥{{order.freightPrice}}</template>
					</el-table-column>
					<el-table-column :label="$t('omsg.pay8')" width="500" align="center">
						<template>
							<span v-for="(item,index) in appreciationList">&ensp;{{item.name}}(￥{{item.price}})</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('omsg.pay9')" width="380" align="center">
						<template>￥{{order.totalPrice}}</template>
					</el-table-column>
					<el-table-column :label="$t('omsg.pay10')" width="140" align="center">
						<template>￥{{order.actuallyPrice}}</template>
					</el-table-column>
					<!-- <el-table-column :label="$t('omsg.pay11')" width="110" align="center">
						<template>￥{{order.alreadyPaidPrice}}</template>
					</el-table-column>
					<el-table-column :label="$t('omsg.pay12')" width="110" align="center">
						<template><span class="text-danger">￥{{order.actuallyPrice-order.alreadyPaidPrice}}</span></template>
					</el-table-column> -->
					<el-table-column :label="$t('omsg.pay13')" min-width="180" align="center">
						<template>
							<span class="link-action" @click="link('/userPageLab/myOrderFreight',{id:id})">查看明细</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		
		
		<!-- 产品信息表格 -->
		<div class="info-card product-card animate__animated  ">
			<div class="card-title-row">
				<el-image :src="asset('47.svg')" class="title-icon"></el-image>
				<span class="title-text">{{$t('omsg.g1')}}</span>
			</div>
			<div class="table-inner">
				<el-table
				ref="productTable"
				:data="packageList"
				border
				header-cell-class-name="od-header-cell"
				cell-class-name="od-cell"
				style="width: 100%"
				:span-method="mergeRows">
					<el-table-column label="#" width="60" align="center">
						<template slot-scope="scope">{{ scope.$index + 1 }}</template>
					</el-table-column>
					<el-table-column :label="$t('omsg.g3')" width="70" align="center">
						<template slot-scope="scope">
							<el-image
							v-if="scope.row.gallery.length"
							:src="scope.row.gallery[0]"
							class="prod-thumb"
							fit="cover"
							:preview-src-list="scope.row.gallery"
							></el-image>
							<el-image v-else :src="imgDef1" class="prod-thumb" fit="cover"></el-image>
						</template>
					</el-table-column>
					<el-table-column prop="expressNumber" :label="$t('omsg.g4')" min-width="140" align="center">
						<template slot-scope="scope">{{scope.row.expressNumber||'?'}}</template>
					</el-table-column>
					<el-table-column prop="name" :label="$t('omsg.g5')" width="160" align="center">
						<template slot-scope="scope">{{scope.row.name||'?'}}</template>
					</el-table-column>
					<el-table-column prop="weight" :label="$t('omsg.g6')" width="140" align="center">
						<template slot-scope="scope">{{scope.row.weight||'?'}}</template>
					</el-table-column>
					<el-table-column prop="volume" :label="$t('omsg.g7')" width="100" align="center">
						<template slot-scope="scope">{{scope.row.volume||'?'}}</template>
					</el-table-column>
					<el-table-column prop="cost" :label="$t('omsg.g8')" width="100" align="center">
						<template slot-scope="scope">{{scope.row.cost||'?'}}</template>
					</el-table-column>
					<el-table-column prop="pieceNum" :label="$t('omsg.g9')" width="100" align="center">
						<template slot-scope="scope">{{scope.row.pieceNum||'?'}}</template>
					</el-table-column>
					<!-- <el-table-column prop="packTypeName" :label="$t('omsg.g10')" width="130" align="center">
						<template slot-scope="scope">{{scope.row.packTypeName||'?'}}</template>
					</el-table-column> -->
					<!-- <el-table-column prop="packNumber" :label="$t('omsg.g11')" min-width="130" align="center">
						<template slot-scope="scope">{{scope.row.packNumber||'?'}}</template>
					</el-table-column> -->
					<el-table-column prop="goodsType" :label="$t('omsg.g12')" width="180" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.goodsType" class="text-primary-sub">{{ scope.row.goodsTypeName.join(',') }}</span>
							<span v-else class="text-primary-sub">?</span>
						</template>
					</el-table-column>
					<!-- 总货值 -->
					<el-table-column :label="$t('omsg.g13')" width="120" align="center">
						<template slot-scope="scope" v-if="scope.$index === 0">
							<span class="text-danger text-bold">{{packagePrice}}</span>
						</template>
					</el-table-column>
					<!-- 总数量 -->
					<el-table-column :label="$t('omsg.g14')" width="120" align="center">
						<template slot-scope="scope" v-if="scope.$index === 0">
							<span class="text-primary text-bold">{{packageNumber}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		
		
		<!-- 打包信息 -->
		<div class="warehouse-row animate__animated  ">
			<!-- 入库信息 -->
			<div class="info-card warehouse-card">
				<div class="card-title-row">
					<el-image :src="asset('27.svg')" class="title-icon"></el-image>
					<span class="title-text">打包信息</span>
				</div>
				<div class="wh-fields">
					<div class="wh-field"><label>{{$t('omsg.ku2')}}：</label><value>{{order.volume}}m³</value></div>
					<div class="wh-field"><label>{{$t('omsg.ku4')}}：</label><value>{{order.weight}}KG</value></div>
					<div class="wh-field"><label>货位号：</label><value>{{order.goodsShelfNumber||$t('omsg.t21')}}</value></div>
					<div class="wh-field"><label>打包时间：</label><value>{{order.packTime||$t('omsg.t21')}}</value></div>
				</div>
				<div class="wh-media-row">
					<div class="wh-media-group" v-if="order.packGallery.length">
						<span class="media-label">打包图片</span>
						<div class="media-list">
							<el-image
								v-for="(img, idx) in order.packGallery"
								:key="'img-'+idx"
								:src="img"
								class="wh-img"
								fit="cover"
								:preview-src-list="whImagesPreview"
								:initial-index="idx"
							></el-image>
						</div>
					</div>
					<div class="wh-media-group" v-if="order.packVideoUrl">
						<span class="media-label">打包视频</span>
						<div class="media-list media-list--video">
							
							<div class="video-cover" v-if="!video1" @click="video1 = true">
								<el-image
									:src="imgDef1"
									class="wh-img"
									fit="cover"
								></el-image>
								<el-image :src="asset('51.svg')" class="play-icon"></el-image>
							</div>
							
							<div class="videoBox" v-if="video1">
								<video controls :src="order.packVideoUrl"></video>
							</div>
							
						</div>
					</div>
				</div>
			</div>
			
		</div>
		
		<!-- ===== 底部签收按钮 ===== -->
		<div class="footer-bar animate__animated  ">
			<button class="sign-btn sign-btn-blue" @click="cancelOrder(order)" v-if="order.status==1">取消订单</button>
			<button class="sign-btn" @click="link('/userPageLab/myOrderPay/',{id:id})" v-if="order.status==2">去支付</button>
			 <button class="sign-btn sign-btn-blue" @click="deleteOrder(order)" v-if="order.status==6">删除订单</button>
			<button class="sign-btn" v-if="order.status==4" @click="signOrder(order)">签收</button>
		</div>

		<!-- 图片预览弹窗 -->
		<el-dialog :visible.sync="imagePreviewVisible" :show-close="false" custom-class="img-preview-dialog">
			<img :src="previewImageUrl" class="preview-img" />
		</el-dialog>
		
		<!-- ===== 取消订单弹出框 ===== -->
		<el-dialog
			:visible.sync="addMarkVisible"
			width="764px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title">取消订单</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisible = false"></el-image>
			</div>
			<div class="dialog-title1">
				确定取消该订单？
			</div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancel" @click="addMarkVisible = false">{{$t('olist.hb5')}}</button>
				<button class="btn-confirm" @click="handleConfirm">确定取消</button>
			</div>
		</el-dialog>
		
		
		<!-- ===== 删除订单弹出框 ===== -->
		<el-dialog
			:visible.sync="addMarkVisibleDel"
			width="764px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title">{{$t('olist.hb7')}}</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisibleDel = false"></el-image>
			</div>
			<div class="dialog-title1">
				{{$t('olist.hb8')}}
			</div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancel" @click="addMarkVisibleDel = false">{{$t('olist.hb5')}}</button>
				<button class="btn-confirm" @click="transportOrderremoveByIdF">{{$t('olist.hb9')}}</button>
			</div>
		</el-dialog>
		
		
		<!-- ===== 签收订单弹出框 ===== -->
		<el-dialog
			:visible.sync="addMarkVisibleSig"
			width="764px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title">{{$t('olist.hb10')}}</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisibleSig = false"></el-image>
			</div>
			<!-- 弹窗内容区 -->
			<div class="dialog-body">
				<div class="form-field">
					<label class="field-label">{{$t('olist.hb11')}}</label>
					<el-input
						v-model="signRemark"
						class="field-input"
						:placeholder="$t('olist.hb12')"
						clearable
					></el-input>
				</div>
				<div class="form-field form-field--upload">
					<label class="field-label field-label--top">{{$t('olist.hb13')}}</label>
					<el-upload accept="image/png, image/jpeg"
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="uplinkportraitSig">
						<el-image class="avatar-img" v-if="signImg" :src="signImg"></el-image>
						<el-image class="avatar-img" v-else :src="require('@/static/add2/65.png')"></el-image>
					</el-upload>
				</div>
			</div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancel" @click="addMarkVisibleSig = false">{{$t('olist.hb5')}}</button>
				<button class="btn-confirm" @click="transportOrdersignOrderF">{{$t('olist.hb14')}}</button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
import {
	transportOrderdetail,
	configbaseDictData,
	transportOrdercancel,
	transportOrderremoveById,
	transportOrdersignOrder,
} from "/src/api/api.js"
export default {
	name: 'OrderDetailPage',
	data() {
		return {
			id:0,
			pmsg:'',
			order:'',
			addressMsg:'',
			transportLine:'',
			trackingList:'',
			warehouse:'',
			appreciationList:'',
			packageList:'',
			packagePrice:'',
			packageNumber:'',
			// 视频播放
			video1:false,
			// 其他
			isLogisticsCollapsed: false,
			imagePreviewVisible: false,
			previewImageUrl: '',
			// 弹出框所选数据
			selItem:'',
			// 弹出框 取消
			addMarkVisible:false,
			// 弹出框 删除
			addMarkVisibleDel:false,
			// 弹出框 签收
			addMarkVisibleSig:false,
			signRemark: '',
			signImg: '',
		}
	},
	computed: {
		totalProductPrice() { return '3000' },
		totalQuantity() { return '400' },
		// 入库图预览
		whImagesPreview() {
			return this.order.gallery.map(img => img)
		},
		packImagesPreview() {
			return this.packImages.map(img => require(`@/static/CodeBuddyAssets/31200_3622/${img}`))
		}
	},
	mounted() {
		this.id = this.$route.query.id
		this.transportOrderdetailF()
	},
	methods: {
		// 订单详情
		async transportOrderdetailF(){
			const res = await transportOrderdetail({id:this.id});
			if(res.code==200){
				this.pmsg = res.data
				this.order = res.data.order
				this.selItem = res.data.order
				this.addressMsg = res.data.address
				this.transportLine = res.data.transportLine
				this.trackingList = res.data.trackingList
				this.warehouse = res.data.warehouse
				this.packageList = res.data.packageList
				this.appreciationList = res.data.appreciationList
				var packagePrice = 0
				var packageNumber = 0
				res.data.packageList.forEach((item)=>{
					packagePrice += item.cost
					packageNumber += item.pieceNum
				})
				this.packagePrice = packagePrice.toFixed(2)*1
				this.packageNumber = packageNumber.toFixed(0)*1
				this.configbaseDictDataF()
			}else{this.Tips(res.msg,'error')}
		},
		// 字典
		async configbaseDictDataF(){
			var data = {}
			const res = await configbaseDictData(data);
			if(res.code==200){
				this.packageList.forEach((item)=>{
					res.data.packageType.forEach((itm)=>{
						if(item.packType*1==itm.dictValue*1){
							item.packTypeName = itm.dictLabel
						}
					})
				})
			}else{this.Tips(res.msg,'error')}
		},
		// 表格索引
		mergeRows({ row, column, rowIndex, columnIndex }) {
		 const columns = this.$refs.productTable.columns;
		   const lastColIndex = columns.length - 1;      // 最后一列索引
		   const secondLastColIndex = columns.length - 2; // 倒数第二列索引
		   
		   // 合并最后两列
		   if (columnIndex === secondLastColIndex) {
			 // 倒数第二列：占2列宽度
			 return { rowspan: 2, colspan: 1 };
		   }
		   
		   if (columnIndex === lastColIndex) {
			 // 最后一列：被合并，不显示
			 return { rowspan: 2, colspan: 1 };
		   }
		},
		// 图片
		asset(name) {
			return require(`@/static/CodeBuddyAssets/31200_3622/${name}`)
		},
		// 复制入仓号
		handleCopy(text) {
			if (navigator.clipboard) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success(this.$t('indexSeach.t12'))
				})
			} else {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success(this.$t('indexSeach.t12'))
			}
		},
		// 物流收缩
		toggleLogistics() {
			this.isLogisticsCollapsed = !this.isLogisticsCollapsed
		},
		// 取消按钮
		cancelOrder(item) {
			this.selItem = item
			this.addMarkVisible = true
		},
		async handleConfirm(){
			var res;
			res = await transportOrdercancel({
				orderId:this.selItem.id,
			});
			if(res.code==200){
				this.addMarkVisible = false
				this.Tips(res.msg)
				this.transportOrderdetailF()
			}else{this.Tips(res.msg,'error')}
		},
		// 删除按钮
		deleteOrder(item) {
			this.selItem = item
			this.addMarkVisibleDel = true
		},
		async transportOrderremoveByIdF(){
			var res;
			res = await transportOrderremoveById({
				orderId:this.selItem.id,
			});
			if(res.code==200){
				this.addMarkVisibleDel = false
				this.Tips(res.msg)
				this.back()
			}else{this.Tips(res.msg,'error')}
		},
		// 签收按钮
		signOrder(item) {
			this.selItem = item
			this.addMarkVisibleSig = true
			this.signRemark = ''
			this.signImg = ''
			if (this.$refs.cancelUploadSig) {
				this.$refs.cancelUploadSig.clearFiles()
			}
		},
		async transportOrdersignOrderF(){
			var res;
			if(!this.signRemark){
				this.Tips(this.$t('olist.hb12'),'error')
				return
			}
			if(!this.signImg.length){
				this.Tips(this.$t('olist.hb12n'),'error')
				return
			}
			res = await transportOrdersignOrder({
				transportOrderId:this.selItem.id,
				signImg:this.signImg,
				signRemark:this.signRemark,
			});
			if(res.code==200){
				this.addMarkVisibleSig = false
				this.Tips(res.msg)
				this.transportOrderdetailF()
			}else{this.Tips(res.msg,'error')}
		},
		// ===== 签收图片上传 =====
		uplinkportraitSig(file) {
			if(file.response){
				this.signImg = file.response.data.url;
			}
		},
	}
}
</script>

<style lang="scss" scoped>
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$danger: #FC2933;
$text-dark: #333333;
$text-gray: #666666;
$text-muted: #999999;
$text-light: #7D7D89;
$label-color: #B1B3B7;
$border-color: #F0F0F0;
$header-bg: #FAFAFA;
$page-bg: #F8F8F8;
$card-radius: 12px;

/* ========== 页面容器 ========== */
.order-detail-page {
	background: $page-bg;
	border-radius: $card-radius;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

/* ========== 面包屑 ========== */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
	margin-bottom: 24px;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover {
		color: #0096FF;
	}
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}
/* ========== 主体区域 ========== */
.detail-body {
	display: flex;
	align-items: flex-start;
}

/* ---- 左侧主区 ---- */
.main-area {
	width: 11.21rem;
	margin-right: 18px;
	flex-shrink: 0;
}

/* ---- 右侧栏 ---- */
.side-area {
	width: 4.48rem;
	flex-shrink: 0;
}

/* ========== 通用卡片 ========== */
.info-card {
	background: white;
	border-radius: $card-radius;
	padding: 24px;
	box-sizing: border-box;
	margin-bottom: 18px;
}

.info-card-nb{
	padding-bottom: 0;
}
.card-title-row {
	display: flex;
	align-items: center;
	height: 28px;
	margin-bottom: 20px;

	.title-icon { width: 2px; height: 16px; flex-shrink: 0; }
	.title-text { font-size: 20px; font-weight: 500; color: $text-dark; margin-left: 10px; }

	&--sm {
		height: 28px;
		margin-bottom: 14px;

		.title-text--sm { font-size: 20px; font-weight: 500; color: $text-dark; margin-left: 12px; }
	}
}
.addrType{
	background: #FFEDED;
	color: #FF4747;
	font-size: 14px;
	height: 26px;
	line-height: 26px;
	border-radius: 4px;
	padding: 0 14px;
}
.addrType1{
	background: #EDF6FF;
	color: #0096FF;
	font-size: 14px;
	height: 26px;
	line-height: 26px;
	border-radius: 4px;
	padding: 0 14px;
}
/* ========== 物流信息卡片 ========== */
.logistics-card {
	padding: 32px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.logistics-left {
		display: flex;
	}
}

.logistics-point {
	display: flex;
	flex-direction: column;

	.point-icon-wrap {
		position: relative;
		width: 16px;
		height: 16px;
	}
	.point-icon-bg { width: 100%; height: 100%; }
	.point-tag {
		position: absolute;
		top: 3px;
		left: 3px;
		font-size: 10px;
		color: white;
		line-height: 1;
	}

	.point-info {
		.addrTxt{
			
		}
		.point-name { margin: 0 8px;display: block; font-size: 16px; font-weight: 500; color: $text-dark; line-height: 1.4; }
		.point-country { display: block; font-size: 14px; font-weight: 500; color: #9CA4BA; }
		.point-desc { display: block; font-size: 14px; color: #9A9C9A; margin-top: 4px; }
	}
}

.arrow-line { width: 40px; height: 28px; margin: 0 54px; }

.logistics-right {
	display: flex;
	align-items: center;

	.warehouse-no { font-size: 16px; font-weight: 500; color: $text-dark; }
	.copy-icon { width: 22px; height: 22px; margin-left: 12px; cursor: pointer; }
}

/* ========== 基本信息卡片 ========== */
.basic-card {
	min-height: 162px;
}

.basic-rows {
	display: flex;
	flex-direction: column;
}

.basic-row {
	display: flex;
	flex-wrap: wrap;
	padding: 0 6px;
	
}

.basic-item {
	display: flex;
	align-items: center;
	font-size: 14px;
	margin-right: 34px;
	margin-bottom: 24px;
	label { color: $label-color; white-space: nowrap; }
	value { color: $text-dark; }
}

.basic-row--1{
	
}
.basic-row--2{
	justify-content: flex-start;
}
.basic-row--2 .basic-item {
	margin-right: 49px;
}
/* ========== 汽车出品资料 ========== */
.material-grid {
	display: flex;
	flex-wrap: wrap;
}

.material-item {
	width: calc(50% - 12px);
	height: 68px;
	background: #FAFAFA;
	border-radius: 8px;
	display: flex;
	align-items: center;
	padding: 0 24px;
	box-sizing: border-box;
	margin-bottom: 18px;
	margin-right: 18px;
	justify-content: space-between;
	&:nth-child(2n) { margin-right: 0; }
	.mat-label { font-size: 16px; color: $text-dark; white-space: nowrap; flex-shrink: 0; }
	.mat-value { 
		font-size: 16px; color: $text-dark;
		width: 310px;
		padding-left: 12px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		.el-image{
			width: 36px;
			border-radius: 4px;
		}
	}
	.bor{
		width: 1px;
		height: 14px;
		background: #0096FF;
		margin: 0 20px;
	}
	.mat-space {
		font-size: 16px;
		color: #0096FF;
		cursor: pointer;
	}
}

/* ========== 产品/费用表格通用样式 ========== */
.table-inner {
	width: 100%;
	margin-top: 4px;
}

::v-deep .od-header-cell {
	background-color: $header-bg !important;
	font-size: 14px !important;
	font-weight: 500 !important;
	color: $text-dark !important;

	.cell { display: flex!important; align-items: center; justify-content: center; height: 46px; line-height: normal; }
}

::v-deep .od-cell {
	font-size: 14px !important;
	font-weight: 400 !important;
	color: $text-gray !important;

	.cell { display: flex; align-items: center; justify-content: center; height: 36px; line-height: normal;}
}

.prod-thumb {
	width: 36px;
	height: 36px;
	border-radius: 6px;
}

.text-danger { color: $danger; }
.text-primary { color: $primary; }
.text-bold { font-weight: 600; }
.text-primary-sub { color: $primary; margin-left: 8px; }
.link-action { color: $primary; cursor: pointer; font-size: 14px; &:hover { opacity: 0.75; } }

/* 费用信息 - 支付明细按钮 */
.fee-card .card-title-row { justify-content: space-between; }
.pay-detail-btn {
	// width: 88px;
	padding: 0 12px;
	height: 32px;
	border-radius: 6px;
	border: 1px solid #EDF6FF;
	background: #EDF6FF;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	color: $primary;
	cursor: pointer;
	flex-shrink: 0;

	&:hover { background: rgba($primary, 0.06); }
}

/* ========== 入库/装柜信息 ========== */
.warehouse-row {
	display: flex;
	justify-content: space-between;
}

.warehouse-card {
	width: calc(50% - 9px);
	width: 100%;
	padding-bottom: 20px;

	&:first-child { margin-right: 0; }
}

.wh-fields {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 16px;
}

.wh-field {
	width: 25%;
	display: flex;
	align-items: center;
	font-size: 14px;
	margin-bottom: 10px;

	label { color: $label-color; white-space: nowrap; }
	value { color: $text-dark; }
}

.wh-media-row {
	display: flex;
	flex-wrap: wrap;
}

.wh-media-group {
	margin-right: 32px;

	.media-label { margin-bottom: 12px;font-size: 14px; color: $text-dark; white-space: nowrap; margin-right: 12px; flex-shrink: 0;display: block; }
}

.media-list {
	display: flex;
	flex-wrap: wrap;
	max-width: 420px;
}

.wh-img {
	width: 72px;
	height: 72px;
	border-radius: 6px;
	margin-right: 8px;
	margin-bottom: 8px;
	cursor: pointer;
	flex-shrink: 0;
}
.videoBox{
	border-radius: 14rpx;
	overflow: hidden;
	video{
		width: 240px;
	}
}
.video-cover {
	position: relative;
	width: 72px;
	height: 72px;
	border-radius: 6px;
	overflow: hidden;
	cursor: pointer;

	.play-icon {
		position: absolute;
		top: 24px;
		left: 24px;
		width: 24px;
		height: 24px;
		z-index: 1;
	}
}

/* ========== 右侧卡片 ========== */
.side-card {
	background: white;
	border-radius: $card-radius;
	padding: 24px;
	box-sizing: border-box;
	margin-bottom: 18px;
}

/* ---- 物流情况 ---- */
.side-header {
	display: flex;
	justify-content: space-between;
	// align-items: center;
	margin-bottom: 16px;
	.card-title-row{
		margin-bottom: 0;
	}
}

.collapse-btn {
	display: flex;
	align-items: center;
	cursor: pointer;

	.collapse-text { font-size: 16px; color: $primary; }
	.collapse-icon { width: 8px; height: 8px; margin-left: 4px; }
}

.status-current {
	font-size: 16px;
	color: $text-dark;
	margin-bottom: 14px;
}

.timeline-wrap {
	display: flex;
	flex-direction: column;
	padding: 0 7px;
	padding-top: 6px;
	// background: pink;
	height: 300px;
	overflow-y: scroll;
}

.timeline-item {
	display: flex;
	align-items: flex-start;
	padding-bottom: 20px;
	position: relative;
	padding-left: 16px;
	border-left: 1px solid #E5E5E5;
	&:last-child{
		border: none;
	}
}

.tl-dot-wrap {
	position: relative;
	width: 14px;
	height: 14px;
	position: absolute;
	top: 0;
	left: 0px;
	transform: translateX(-50%);
	.el-image{
		width: 14px;
		height: 14px;
		background: #fff;
	}
}


.tl-content {
	transform: translateY(-5px);
	.tl-name { font-size: 16px; letter-spacing: 0.48px; margin-bottom: 4px; color: #BCBCBC; }
	.a1{
		color: #0096FF;
		font-weight: bold;
	}
	.tl-time { font-size: 14px; color: #BCBCBC; }
	.a2{
		color: #333333;
	}
}

/* ---- 联系人信息 ---- */
.cf-item {
	font-size: 14px;
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	label { color: $label-color; white-space: nowrap; }
	value { color: $text-dark; }
}
.userMsg{
	margin-bottom: 12px;
	.contact-avatar {
		margin-right: 12px;
		.avatar-img { width: 56px; height: 56px;border-radius: 6px;}
	}
	.contact-fields { display: flex; flex-direction: column;padding-top: 6px; }
}

.contact-section--last .contact-divider { margin-top: 0; }

.nameBox{
	margin-bottom: 6px;
	.cf-item{
		&:last-child{
			margin-left: 56px;
		}
	}
	width: 100%;
}

.cf-full { display: flex; flex-wrap: wrap; }



.cf-item--address { width: 100%; }
.addr-country { color: #0096FF!important;padding-right: 9px; }
.cf-item--addr-text { width: 100%; margin-top: -4px; padding-left: 56px; box-sizing: border-box; }

/* ========== 底部签收按钮 ========== */
.footer-bar {
	display: flex;
	justify-content: flex-end;
	padding-top: 16px;
}

.sign-btn {
	width: 184px;
	height: 60px;
	background: $primary;
	border: 1px solid $primary;
	border-radius: 10px;
	font-size: 18px;
	font-weight: 500;
	color: white;
	cursor: pointer;
	transition: opacity 0.25s;
	
	margin-left: 12px;

	&:hover { opacity: 0.88; }
	&:active { opacity: 1; }
}

.sign-btn-blue{
	background: #f8f8f8;
	border: 1px solid #0096FF;
	color: #0096FF;
}

/* ========== 图片预览弹窗 ========== */
::v-deep .img-preview-dialog {
	background: transparent;
	box-shadow: none;
	border: none;
	padding: 0;

	.el-dialog__header { display: none; }
	.el-dialog__body { padding: 0; text-align: center; }
	.preview-img { max-width: 800px; max-height: 600px; border-radius: 8px; }
}

@media (prefers-reduced-motion: reduce) {
	.animate__animated { animation: none !important; }
	* { transition-duration: 0.01ms !important; }
}

.contact-card{
	padding-bottom: 10px;
}

.zwBox{
	height: 344px;
}


/* ================================================================
   添加唛头弹窗样式
   ================================================================ */

::v-deep .add-mark-dialog {
	border-radius: 8px;
	overflow: hidden;

	.el-dialog__header {
		padding: 0;
		margin: 0;
	}

	.el-dialog__body {
		padding: 30px 32px 20px;
		padding-bottom: 32px;
	}

	.el-dialog__footer {
		padding: 0 32px 28px;
	}
}


/* ---- 弹窗头部 ---- */
.dialog-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 69px;
	background: #f7fafc;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
	box-sizing: border-box;
}

.dialog-title {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
}

.dialog-title1 {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
	text-align: center;
}

.dialog-close-icon {
	width: 16px;
	height: 16px;
	cursor: pointer;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.7;
	}
}


/* ---- 弹窗内容区 ---- */
.dialog-body {
	display: flex;
	flex-direction: column;
}


/* 表单字段行 */
.form-field {
	display: flex;
	align-items: center;
	margin: auto;
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}


/* 字段标签 */
.field-label {
	width: 80px;
	text-align: right;
	font-size: 16px;
	font-weight: 400;
	color: #9A9DA7;
	flex-shrink: 0;
	line-height: 45px;
	margin-right: 14px;

	&--center {
		text-align: center;
	}
}


/* 输入框 */
.field-input {
	width: 307px;
	
	.el-input__inner {
		height: 41px;
		line-height: 41px;
		border: 2px solid #E8EDF4;
		border-radius: 8px;
		font-size: 16px;
		color: #333333;
		padding: 0 16px;

		&::placeholder {
			color: #999999;
		}

		&:focus {
			border-color: #0096FF;
		}
	}
}

/* ---- 图片上传区域 ---- */
.form-field--upload {
	align-items: flex-start;

	.upload-container {
		flex: 1;
		width: 307px;
		display: flex;
		flex-wrap: wrap;
		
		::v-deep .el-upload--picture-card {
			width: 90px;
			height: 90px;
			border-radius: 8px;
			border: 1px dashed #DCDFE6;
			background: #FAFAFA;
			line-height: normal;
			display: flex;
			align-items: center;
			justify-content: center;

			&:hover {
				border-color: #0096FF;
				background: #F0F9FF;
			}

			i {
				font-size: 24px;
				color: #C0C4CC;
			}
		}

		::v-deep .el-upload-list--picture-card .el-upload-list__item {
			width: 90px;
			height: 90px;
			border-radius: 8px;
			margin-right: 10px;
			margin-bottom: 10px;
		}
	}

	.upload-tip {
		margin-top: 8px;
		font-size: 12px;
		color: #999999;
		line-height: 1.5;
	}
}

/* 顶部对齐标签 */
.field-label--top {
	line-height: normal;
	padding-top: 8px;
}

/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 4px;
}


/* 返回按钮 */
.btn-cancel {
	width: 120px;
	height: 44px;
	background: #E9F6FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}

/* 确认修改按钮 */
.btn-confirm {
	width: 120px;
	height: 44px;
	background: #0096FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}
.avatar-img {
	width: 0.90rem;
	height: 0.90rem;
	border-radius: 0.06rem;
	flex-shrink: 0;
}
.avatar-uploader{
	width: 307px;
}
</style>
